import React from 'react'
import CollectionMainPage from "../page/CollectionMainPage"



function BanglesPage({categoryType} ) {
  return (
    <CollectionMainPage categoryType={categoryType}/>
  )
}

export default BanglesPage